export default __webpack_public_path__ + "static/media/Fantasy_13.7c345cda.png";